module.exports = __webpack_public_path__ + "img/logoFunEatsBlanco.27d1edb2.svg";